import React, { useState } from 'react';
import './CalculatorPage.css';

function LifePathNumberCalculator() {
  const [dob, setDob] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const calculate = (dateString) => {
    // Life Path Number calculation logic (similar to Bhagyank/Destiny Number)
    const digitsOnly = dateString.replace(/\D/g, '');

    if (digitsOnly.length !== 8) {
      return null; // Invalid length
    }

    const day = parseInt(digitsOnly.substring(0, 2), 10);
    const month = parseInt(digitsOnly.substring(2, 4), 10);
    const year = parseInt(digitsOnly.substring(4, 8), 10);

    if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1900 || year > 2100) {
      return null; // Invalid date components
    }

    let sum = 0;
    for (let i = 0; i < digitsOnly.length; i++) {
      sum += parseInt(digitsOnly[i], 10);
    }

    while (sum > 9 && sum !== 11 && sum !== 22 && sum !== 33) { // Master numbers 11, 22, 33 are not reduced
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }
    return sum;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!dateRegex.test(dob)) {
      setError('Please enter a valid date in DD/MM/YYYY format.');
      return;
    }

    const calculated = calculate(dob);
    if (calculated === null) {
      setError('Invalid date. Please check your input.');
    } else {
      setResult(calculated);
    }
  };

  const getExplanation = (num) => {
    return `Life Path Number ${num}: This is a placeholder explanation for Life Path Number ${num}.`;
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Life Path Number Calculator",
    "description": "Calculate your Life Path Number based on your birth date and understand its significance.",
    "url": "https://www.yourwebsite.com/life-path-number-calculator",
    "potentialAction": {
      "@type": "CalculateAction",
      "name": "Calculate Life Path Number",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/life-path-number-calculator?dob={dob}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": "required name=dob"
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Life Path Number Calculator</h1>
      <p className="text-center">Enter your Date of Birth to discover your Life Path Number.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="dob">Date of Birth (DD/MM/YYYY):</label>
          <input
            type="text"
            id="dob"
            className="form-control"
            value={dob}
            onChange={(e) => setDob(e.target.value)}
            placeholder="e.g., 01/01/1990"
            maxLength="10"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Calculate Life Path Number</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Your Life Path Number is: <span className="result-number">{result}</span></h2>
          <p className="result-explanation">{getExplanation(result)}</p>
        </div>
      )}
    </div>
  );
}

export default LifePathNumberCalculator;
